// Functionality for Secondary Nav Dropdown Menus - Harnessing Mega Menu Overlay Effect
import $ from 'jquery';

if ($('.mega-menu-overlay').length) {
  const $overlay = $('.mega-menu-overlay');

  // Toggle On
  $('.nav-secondary__link').on('mouseenter', (event) => {
    // If secondary nav item has a caret child then open up!
    const $self = $(event.target);
    if ($self.find('.caret').length) {
      $overlay.addClass('nav-secondary--open');
    }
  });

  $('.nav-secondary__submenu').on('mouseover', (event) => {
    $overlay.addClass('nav-secondary--open');
  });

  // Toggle Off
  $('.nav-secondary__link').on('mouseleave', (event) => {
    $overlay.removeClass('nav-secondary--open');
  });

  $('.nav-secondary__submenu').on('mouseleave', (event) => {
    $overlay.removeClass('nav-secondary--open');
  });
}
